import { ApiService } from 'services';

import { handleException } from 'actions/exceptions';

export const GET_FORMS_REQUEST = 'GET_FORMS_REQUEST';
export const GET_FORMS_SUCCESS = 'GET_FORMS_SUCCESS';
export const GET_FORMS_FAILURE = 'GET_FORMS_FAILURE';

function requestGetForms() {
  return {
    type: GET_FORMS_REQUEST,
    isGettingForms: true
  };
}

function receiveGetForms(forms, formsCount, gridTotalLimit) {
  return {
    type: GET_FORMS_SUCCESS,
    isGettingForms: false,
    forms,
    formsCount,
    gridTotalLimit
  };
}

function rejectGetForms() {
  return {
    type: GET_FORMS_FAILURE,
    isGettingForms: false
  };
}

export function getForms(pageNumber, pageSize, totalLimit, sortByField, sortDirection, filterList, searchQuery, legalEntity, legalEntitySelected, accountNumber, accountNumberSelected, customer, customerSelected, formFamilies) {
  return (dispatch) => {
    dispatch(requestGetForms());
    const promise = () => ApiService
      .getForms(pageNumber, pageSize, totalLimit, sortByField, sortDirection, filterList, searchQuery, legalEntity, legalEntitySelected, accountNumber, accountNumberSelected, customer, customerSelected, formFamilies)
      .then((response) => {
        dispatch(receiveGetForms(response.data.items, response.data.totalCount, response.data.totalLimit));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetForms, true));
        }
      });
    return promise();
  };
}

export function getFormsByObject(requestObject) {
  return getForms(
    requestObject.pageNumber,
    requestObject.pageSize,
    requestObject.totalLimit,
    requestObject.sortByField,
    requestObject.sortDirection,
    requestObject.filterList,
    requestObject.searchQuery,
    requestObject.legalEntity,
    requestObject.legalEntitySelected,
    requestObject.accountNumber,
    requestObject.accountNumberSelected,
    requestObject.customer,
    requestObject.customerSelected,
    requestObject.formFamilies
  );
}
